import script from "./DocumentPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&setup=true&lang=js"

import "./DocumentPreview.vue?vue&type=style&index=0&id=93244b10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93244b10"]])

export default __exports__